import email from "@/constants/email"

export default {
  getElecWithinTolerance(data) {
    return `<html>
      <body>
          <div style='max-width:700px; padding: 10px; margin: 0 auto;'>
            Hello ${data.customer_firstname},
            <br>
            <br>Account Number: ${data.account_number}
            <br>MPAN: ${data.mpxn}
            <br>
            <br>We're contacting you today because your opening electricity reading${data.plural} ${data.has_have} failed <a href='https://help.so.energy/support/solutions/articles/7000046241-opening-reading-validation-process' target='_blank'><b>validation</b></a>.
            <br>
            <br>You provided the following reading${data.plural}: ${data.customer_read}
            <br>
            <br>We have been provided with ${data.plural_an}estimate${data.plural} to use instead.
            Estimates are given to us by industry based on your meter reading history and estimated energy usage.
            <br>
            <br>We will be opening your account with ${data.plural_an}estimated reading${data.plural}: ${data.industry_read}.
            <br>
            <br>
            The same estimate${data.plural} ${data.has_have} been given to your previous supplier as
            your final reading${data.plural} to be used on your final bill, so you will not be charged twice for any energy.
            Their final bill should be with you in the next couple of weeks. Please contact your old supplier
            first if you are concerned that this is taking a long time.
            <br>
            <br>The estimate${data.plural} we have been given is very similar to, or 'within tolerance' of the reading you gave us.
            This means, as much as we would prefer to use your reading (as we're sure you would too!) the energy industry will not allow
            us to dispute the estimate. At this point So Energy and your previous supplier must use this reading for your switch.
            The estimate is sensible and could reasonably have been taken around the time of your switch,
            and the important thing to remember is that you will not be charged twice for the same energy.
            <br>
            <br>If you have any queries, please do get in touch.
          </div>
          ${email.footer}
      </body>
    </html>
    `
  },
  getElecOutofTolerance(data) {
    return `<html>
      <body>
        <div style='max-width:700px; padding: 10px; margin: 0 auto;'>
          Hello ${data.customer_firstname},
          <br>
          <br>Account Number: ${data.account_number}
          <br>MPAN: ${data.mpxn}
          <br>
          <br>We're contacting you today because your opening electricity reading${data.plural} ${data.has_have} failed
          <a href='https://help.so.energy/support/solutions/articles/7000046241-opening-reading-validation-process' target='_blank'><b>validation</b></a>.
          <br>
          <br>You provided the following reading${data.plural}: ${data.customer_read}
          <br>
          <br>We have been provided with ${data.plural_an}estimate${data.plural} to use instead.
          Estimates are given to us by industry based on your meter reading history and estimated energy usage.
          <br>
          <br>We will be opening your account with ${data.plural_an}estimated reading${data.plural}: ${data.industry_read}.
          <br>
          <br>
          If you are happy with the estimated reading${data.plural} no action is necessary.
          The same estimate${data.plural} ${data.has_have} been given to your previous supplier as
          your final reading${data.plural} to be used on your final bill, so you will not be charged twice for any energy.
          Their final bill should be with you in the next couple of weeks. Please contact your old supplier
          first if you are concerned that this is taking a long time.
          <br>
          <br><i>Is the opening reading you gave us correct?</i>
          <br>
          <br>If you think your opening read is correct and this validation process isn't working properly
          then we'd love to help out. We can raise a 'dispute', and we can get the opening reading amended for you.
          To do so, we will need clear photographs of your electricity meter, showing the full front of the meter
          including serial number (a series of letters and/or numbers printed on the meter).
          You can just reply to this email with the photographs attached.
          <br>
          <br>You can also read our handy guide for we've made which explains this process: <a href='https://help.so.energy/support/solutions/articles/7000046447-my-opening-reading-is-wrong' target='_blank'><b>My opening or closing reading is wrong</b></a>.
          <br>
          <br>If you have any queries, please do get in touch.
        </div>
        ${email.footer}
      </body>
    </html>`
  },
  getElecTransposed(data) {
    return `<html>
      <body>
        <div style='max-width:700px; padding: 10px; margin: 0 auto;'>
            Hello ${data.customer_firstname},
            <br>
            <br>Account Number: ${data.account_number}
            <br>MPAN: ${data.mpxn}
            <br>
            <br>We're contacting you today because the opening electricity readings you provided ${data.customer_read} have failed validation as central industry have deemed the reads to be the wrong way around for Day and Night.
            <br>
            <br>We will be opening your account with the reads you provided the following way around: <b>${data.industry_read}</b>.
            <br>
            <br>Your previous supplier will also generate your final bill to the above reads, so please rest assured, you will not be charged twice for any electricity consumed.
            <br>
            <br>If you are happy for us to use your opening reads this way around, no action is required.
            <br>
            <br>If you think your opening read is correct and this validation process isn't working properly then we'd love to help out.
            In order to dispute your opening readings you will be required to complete a
            <a href='https://www.so.energy/so/help-and-advice/faq/your-meter/how-do-i-know-which-register-is-day-night' target='_blank'><b>Time Test</b></a>.
            To complete the Time Test, please take readings from your electricity meter in the middle of the day, and then take more readings a few hours later.
            Only one of the readings should have changed and this will be (or should be) the Day reading.
            Please take photographs of all meter readings if possible and send them in a reply to this email.
            <br>
            <br>If you have any queries, please do get in touch.
          </div>
          ${email.footer}
      </body>
    </html>`
  },
  getGasWithinTolerance(data) {
    return `<html>
      <body>
        <div style='max-width:700px; padding: 10px; margin: 0 auto;'>
            Hello ${data.customer_firstname},
            <br>
            <br>Account Number: ${data.account_number}
            <br>MPRN: ${data.mprn}
            <br>
            <br>We're contacting you today because your opening gas reading failed <a href='https://help.so.energy/support/solutions/articles/7000046241-opening-reading-validation-process' target='_blank'><b>validation</b></a>.
            <br>
            <br>You provided the following reading: ${data.customer_read}${data.unit}
            <br>
            <br>We have been provided with an estimate to use instead. Estimates are given to us by industry based on your meter reading history and estimated energy usage.
            <br>
            <br>We will be opening your account with an estimated read: ${data.industry_read}${data.unit}.
            <br>
            <br>
            The same estimate has been given to your previous supplier as your final reading
            to be used on your final bill, so you will not be charged twice for any energy.
            Their final bill should be with you in the next couple of weeks.
            Please contact your old supplier first if you are concerned that this is taking a long time.
            <br>
            <br>The estimate we have been given is very similar to, or 'within tolerance' of the reading you gave us.
            This means, as much as we would prefer to use your reading (as we're sure you would too!) the energy industry will not allow
            us to dispute the estimate. At this point So Energy and your previous supplier must use this reading for your switch.
            The estimate is sensible and could reasonably have been taken around the time of your switch,
            and the important thing to remember is that you will not be charged twice for the same energy.
            <br>
            <br>If you have any queries, please do get in touch.
          </div>
          ${email.footer}
      </body>
    </html>`
  },
  getGasOutofTolerance(data) {
    return `<html>
      <body>
        <div style='max-width:700px; padding: 10px; margin: 0 auto;'>
            Hello ${data.customer_firstname},
            <br>
            <br>Account Number: ${data.account_number}
            <br>MPRN: ${data.mprn}
            <br>
            <br>We're contacting you today because your opening gas reading failed <a href='https://help.so.energy/support/solutions/articles/7000046241-opening-reading-validation-process' target='_blank'><b>validation</b></a>.
            <br>
            <br>You provided the following reading: ${data.customer_read}${data.unit}
            <br>
            <br>We have been provided with an estimate to use instead. Estimates are given to us by industry based on your meter reading history and estimated energy usage.
            <br>
            <br>We will be opening your account with an estimated read: ${data.industry_read}${data.unit}.
            <br>
            <br>If you are happy with the estimated reading no action is necessary.
            The same estimate has been given to your previous supplier as your final reading
            to be used on your final bill, so you will not be charged twice for any energy.
            Their final bill should be with you in the next couple of weeks.
            Please contact your old supplier first if you are concerned that this is taking a long time.
            <br>
            <br><i>Is the opening reading you gave us correct?</i>
            <br>
            <br>If you think your opening read is correct and this validation process isn't working properly then we'd love to help out.
            We can raise a 'dispute' on your reading and get the reading you provided amended.
            To do so, we will need clear photographs of your gas meter,
            showing the full front of the meter including serial number (a series of letters and/or numbers printed on the meter).
            You can just reply to this email with the photographs attached.
            <br>
            <br>You can also read our handy guide for we've made which explains this process: <a href='https://help.so.energy/support/solutions/articles/7000046447-my-opening-reading-is-wrong' target='_blank'><b>My opening or closing reading is wrong</b></a>.
            <br>
            <br>If you have any queries, please do get in touch.
          </div>
          ${email.footer}
      </body>
    </html>`
  },
}
